export default "__VITE_ASSET__e10f539b__"